import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  NumberInput,
  required,
} from "react-admin";

export const ProviderCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput
        source="code"
        label="Code"
        validate={required()}
        helperText="Unique provider code (e.g., 'ratehawk', 'bookingcom')"
      />
      <TextInput source="name" validate={required()} />
      <SelectInput
        source="type"
        choices={[
          { id: "hotel", name: "Hotel" },
          { id: "flight", name: "Flight" },
          { id: "car_rental", name: "Car Rental" },
          { id: "activity", name: "Activity" },
          { id: "package", name: "Package" },
        ]}
        validate={required()}
      />
      <TextInput source="description" multiline rows={4} />
      <NumberInput
        source="priority"
        helperText="Priority for provider selection (lower = higher priority)"
        defaultValue={100}
      />
      <SelectInput
        source="status"
        choices={[
          { id: "active", name: "Active" },
          { id: "inactive", name: "Inactive" },
          { id: "maintenance", name: "Maintenance" },
          { id: "deprecated", name: "Deprecated" },
        ]}
        defaultValue="inactive"
        helperText="Initial status (default: inactive)"
      />
    </SimpleForm>
  </Create>
);
